import axios from "axios";

export function getAppReport(recruitmentCycleId, searchTxt) {
    return axios.get("/api/services/app/ApplicationReports/GetAppReport", { params: { recruitmentCycleId, searchTxt } });
}

export function exportAppReport(recruitmentCycleId, searchTxt) {
    return axios.post("/api/services/app/ApplicationReports/ExportAppReport", null, { params: { recruitmentCycleId, searchTxt } });
}
